import { openModal } from "action/modal/openModal";
import classNames from "classnames";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getVehicleName } from "util/helper/getVehicleName";
import { DEFAULT_FORMAT } from "util/helper/helper";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import HideIf from "../../../../util/HideIf";
import { validateVehicle } from "../../../../util/vehicle/validate-vehicle";
import styles from "./garage-info.module.scss";

function GarageInfo(props: any) {
  const { garageTitle, hideVehicleSelector } = props;

  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const fitmentOptionKeys = selectedVehicle?.fitmentOptions.map((option) => option.optionName) || [];

  const fitmentTitle = getVehicleName(selectedVehicle, DEFAULT_FORMAT, fitmentOptionKeys);

  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  return (
    <div className={classNames("d-flex flex-column", {
      "align-items-center": !hideVehicleSelector,
    })}
    >
      <HideIf show={!hideVehicleSelector}>
        <div>

          <img
            alt={selectedVehicle.make}
            className="object"
            src={createMakeImageSource(selectedVehicle)}
            style={{ width: "calc(6 * var(--safari-root-font, 10px))" }}
          />
        </div>
      </HideIf>

      <div>

        <HideIf show={!validateVehicle(selectedVehicle)}>

          <h4>

            <strong>

              <span>{t("ALL VEHICLES")}</span>
            </strong>
          </h4>
        </HideIf>

        <HideIf show={validateVehicle(selectedVehicle) && garageTitle}>
          <h1 className={classNames({
            [styles.category_name]: hideVehicleSelector,
          })}
          >
            {garageTitle}

            <HideIf show={fitmentTitle}>

              <div
                onClick={() => dispatch(openModal("vehicleSelector", {
                  defaultMake: selectedVehicle.make,
                  defaultModel: selectedVehicle.model,
                  defaultYear: selectedVehicle.year,
                  forceNextAttribute: true,
                }))}
                className={styles.fitment_name}
                data-testid="fitment-name"
              >
                {fitmentTitle}
              </div>
            </HideIf>
          </h1>
        </HideIf>

        <HideIf show={validateVehicle(selectedVehicle) && !garageTitle}>

          <h4>

            <strong>

              <div>

                <span>
                  {`${selectedVehicle.year} ${selectedVehicle.make} ${selectedVehicle.model}`}
                </span>
              </div>
            </strong>
          </h4>
        </HideIf>
      </div>
    </div>
  );
}

export default GarageInfo;
